/**
 * Created by hp on 2017/6/26.
 * {isShowMoney && ("￥" + renderMoney(money))}订阅按钮内部
 * let isShowMoney = !(discount && discount.price);
 */
import React,{Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import {Button} from 'react-weui';
import Config from '../../config';
import {WKOwnDialog} from '../wk'
import {setEvent} from '../../services'
import {renderMoney} from '../../utils';


class ChannelSinglePayChannel extends Component{
    constructor() {
        super();
        this.state = {
            dialogShow: false
        }
        this.handlePayChannel = this.handlePayChannel.bind(this);
    }

    getName() {
        if(sessionStorage.getItem('autoPlayIntroAudio') === '0'){
            return 'zhuanlanfangana'
        }else if(sessionStorage.getItem('autoPlayIntroAudio') === '1'){
            return 'zhuanlanfanganb'
        }
    }

    handlePayChannel() {
        const {channelId, discount, spCallbackUrl, spTransactionId, newCoupon} = this.props;

        this.getName() && window.MtaH5 && window.MtaH5.clickStat(this.getName(),{'startpay':'true'})
        setEvent({name: 'wk_channel-pay-normal'})
        if ((discount && discount.price) || (newCoupon.hasCoupon && newCoupon.canUseCouponBuy)) {
            this.props.dispatch({
                type: 'CHANNEL_SHOW_PAY_PANEL'
            });
            if (this.props.newCoupon.couponData) {
                this.props.dispatch({
                    type: 'CHANNEL_SET_DISCOUNT',
                    payload: this.props.newCoupon.couponData
                })
            }
        } else {
            const {meta} = this.props
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: {
                        product: 'pay_channel',
                        channel_id: channelId,
                        platform: meta.platform,
                        user_sign: meta.user_sign,
                    },
                    success: () => {
                        this.getName() && window.MtaH5 && window.MtaH5.clickStat(this.getName(),{'paysuccess':'true'})

                        if (spCallbackUrl && spTransactionId) {
                            const data = {sp_callback_url: spCallbackUrl, sp_transaction_id: spTransactionId, object_id: channelId, type: 'channel'};
                            axios.post(`/api/open_auth/callback `, qs.stringify(data)).then(res => {
                                if (res.data.code === 0) {
                                    window.location = Config.MAIN_URL + `/channel/${channelId}/paysuccess${location.search}`;
                                }
                            });
                        } else {
                            if ([107868].indexOf(channelId) > -1) { // 专栏特例购买成功跳转到报名页
                                window.location = Config.MAIN_URL + `/liveroom/pay_success_goods?channel_id=${channelId}`;
                            } else {
                                window.location = Config.MAIN_URL + `/channel/${channelId}/paysuccess${location.search}`
                            }
                        }
                    },
                    cancel: () => {
                        if (/lzwk_article/.test(window.location.search) && /31355018/.test(window.location.search) && false) {
                            this.setState({
                                dialogShow: true
                            }, () => {
                                this.props.dispatch({ type: 'MTA_CLICK', payload: 'lzwk_article_cancel_show' })
                            })
                        }
                    }
                }
            })
        }
    }

    componentDidMount() {
         this.getName() && window.MtaH5 && window.MtaH5.clickStat(this.getName(),{'browse':'true'})
    }

    render() {
        return(
            <div style={{width: '100%'}}>
                <WKOwnDialog show={this.state.dialogShow} buttons={[
                    {
                        label: '再看看',
                        type: 'default',
                        onClick: () => {
                            this.setState({
                                dialogShow: false
                            })
                        }
                    },
                    {
                        label: '准备好了',
                        onClick: () => {
                            this.setState({
                                dialogShow: false
                            }, () => {
                                this.handlePayChannel()
                                this.props.dispatch({ type: 'MTA_CLICK', payload: 'lzwk_article_cancel_click_pay' })
                            })
                        }
                    }
                ]}>
                    <p style={{textAlign: 'left', fontSize: '16px'}}>唯有不断学习，才能成为更好的自己。你准备好了吗？</p>
                    <p style={{textAlign: 'left', fontSize: '16px'}}>课程正在限时优惠中……</p>
                </WKOwnDialog>
                <Button className="weui-flex__item flex_3 class_for_maincoupon" onClick={this.handlePayChannel}>
                    购买专栏
                </Button>
            </div>
        )
    }
}

export default connect((state) => ({
    channelId: state.channel.channel.id,
    money: state.channel.channel.money,
    discount: state.channel.discount,
    spCallbackUrl: state.channel.spCallbackUrl,
    spTransactionId: state.channel.spTransactionId,
    newCoupon: state.newCoupon,
    meta: state.channel.meta,
}))(ChannelSinglePayChannel)



// WEBPACK FOOTER //
// ./src/components/channel/ChannelSinglePayChannel.js